var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdgeCurvUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 81,
    viewBox: "0 0 800 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M800 52.9486V25.1977C624.62 47.3535 363.693 72.9953 0 20.7543V26.9543C194.077 66.3694 444.67 86.9031 800 52.9486Z",
    fill: "#DADADA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M799.836 0V28.6269C477.208 65.202 204.744 56.7059 0 21V12.6037C348.249 57.5215 647.011 21.5377 799.836 0Z",
    fill: "#88219F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M799.673 48.4386C464.877 87.1053 235.637 66.7544 0 23V81H799.673V48.4386Z",
    fill: "#88219F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdgeCurvUp);
export default __webpack_public_path__ + "static/media/edgeCurv-Up.45b21787c10c30ae758640612c06cd00.svg";
export { ForwardRef as ReactComponent };